import React from 'react';

const IndustriesWeTransform = () => {
  const industries = [
    {
      id: 1,
      image: '/assets/digitalTransformation/5section-1.svg',
      title: 'Healthcare'
    },
    {
      id: 2,
      image: '/assets/digitalTransformation/5section-2.svg',
      title: 'Life Sciences'
    },
    {
      id: 3,
      image: '/assets/digitalTransformation/5section-3.svg',
      title: 'Insurance'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10 lg:mb-12">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">Industries We </span>
            <span className="secondary-text">Transform</span>
          </h2>
          <p className="   max-w-4xl mx-auto px-4 leading-relaxed">
            Delivering AI-driven digital transformation across diverse industries through intelligent platforms, scalable 
            solutions, and measurable outcomes.
          </p>
        </div>

        {/* Light Blue Section with Cards */}
        <div className="light-blue-bg rounded-xl py-10 md:py-14 lg:py-18 px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 lg:gap-12 max-w-5xl mx-auto">
            {industries.map((industry) => (
              <div
                key={industry.id}
                className="industry-card"
              >
                <div className="relative overflow-hidden rounded-xl shadow-xl cursor-pointer h-[120px] md:h-[160px]">
                  {/* Background Image */}
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-full object-cover"
                  />
                  
                  {/* Dark Overlay with Opacity */}
                  <div className="absolute inset-0 bg-black/40" />
                  
                  {/* Blue Overlay with Opacity */}
                  <div className="absolute inset-0 primary-bg opacity-50" />
                  
                  {/* Centered Title */}
                  <div className="absolute inset-0 flex items-center justify-center p-6">
                    <h3 className="text-white    text-center leading-tight">
                      {industry.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeTransform;